import type { DecimalString, Uuid } from './subprojects';

export interface Supplier {
  id: Uuid;
  name: string;
  contact: string | null;
  email: string | null;
  phone: string | null;
  category_ids: Uuid[];
  categories: string[];
  desvio_comercial_pct: DecimalString;
  beneficio_comercial_pct: DecimalString;
  notes: string | null;
  active: boolean;
  created_at: string;
  updated_at: string;
  items_count: number;
}

export interface SupplierFilters {
  search?: string;
  active?: boolean;
  category_ids?: Uuid[];
  include_uncategorized?: boolean;
}

export interface SupplierPagination {
  page: number;
  page_size: number;
  total?: number;
  total_pages?: number;
}

export interface SuppliersResponse {
  items: Supplier[];
  pagination: SupplierPagination;
}

export interface SupplierCreatePayload {
  name: string;
  contact?: string | null;
  email: string;
  phone?: string | null;
  category_ids?: Uuid[];
  desvio_comercial_pct?: DecimalString;
  beneficio_comercial_pct?: DecimalString;
  notes?: string | null;
  active?: boolean;
}

export type SupplierUpdatePayload = Partial<SupplierCreatePayload>;

export function normalizeSuppliersResponse(raw: any): SuppliersResponse {
  const rawItems = Array.isArray(raw) ? raw : raw?.items ?? raw?.data ?? [];
  const items = Array.isArray(rawItems) ? rawItems : Array.isArray(rawItems.items) ? rawItems.items : [];

  const pagination = raw?.pagination ?? raw?.data?.pagination ?? {};
  const fallbackPageSize = items.length || 1;

  return {
    items,
    pagination: {
      total: pagination.total ?? raw?.total ?? items.length,
      page: pagination.page ?? raw?.page ?? 1,
      page_size: pagination.page_size ?? raw?.page_size ?? raw?.per_page ?? fallbackPageSize,
      total_pages:
        pagination.total_pages ??
        raw?.total_pages ??
        Math.max(
          1,
          Math.ceil(
            (pagination.total ?? raw?.total ?? items.length)
            / (pagination.page_size ?? raw?.page_size ?? raw?.per_page ?? fallbackPageSize),
          ),
        ),
    },
  };
}
